import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'delinquency-restriction-dialog',
    templateUrl: './delinquency-restriction-dialog.component.html',
    standalone: false
})
export class DelinquencyRestrictionDialogComponent {
    public isOrgBillingAdminUser = false;

    constructor(
    public dialogRef: MatDialogRef<DelinquencyRestrictionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.isOrgBillingAdminUser = this.data.isOrgBillingAdminUser;
    }
}
